import React, { useState, useRef, useEffect } from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Overlay,
  Popover,
  Button,
} from "react-bootstrap";
import ReactSelect from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import Flatpickr from "react-flatpickr";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchIndustryData,
  setSelectedIndustry,
} from "../../redux/actions/industryActions";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import {
  fetchCompanyCategories,
  selectCompanyCategory,
} from "../../redux/actions/companyCategoryActions";
import { fetchJobType, selectJobType } from "../../redux/actions/jobTypeAction";
import {
  fetchWorkLevelTypeData,
  selectWorkLevel,
} from "../../redux/actions/workLevelTypeAction";
import {
  fetchWorkLocationTypeData,
  selectLocationType,
  selectWorkLocation,
} from "../../redux/actions/workLLocationTypeAction";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { customStyles } from "../../selectStyles";
import axiosInstance from "../../API/axios";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import { useParams } from "react-router-dom";
import {
  fetchCompanyData,
  selectGetCompanies,
} from "../../redux/actions/getCompaniesAction";
import moment from "moment";
import { fetchOrgRegdCompData } from "../../redux/actions/getRegdComAction";

const EditExperience = ({
  show,
  handleClose,
  userCcv,
  getUserCv,
  userDataInfo,
  experienceData,
}) => {
  const [institution, setInstitution] = useState(null);
  const [city, setCity] = useState(null);
  const [field, setField] = useState("");
  const [degree, setDegree] = useState("");
  const [grade, setGrade] = useState("");
  const [isPresent, setIsPresent] = useState(false);
  const [startYear, setStartYear] = useState("");
  const [endYear, setEndYear] = useState("");
  const [description, setDescription] = useState("");
  const [activities, setActivities] = useState("");

  const [showTooltip, setShowTooltip] = useState(false);
  const targetRef = useRef(null);
  const [newEducation, setNewEducation] = useState("");

  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams();

  const [profileHeadLine, setProfileHeadLine] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [designation, setDesignation] = useState("");
  const [OrganizationName, setOrganizationName] = useState("");
  const [display, setDisplay] = useState(false);
  const [newOrgType, setnewOrgType] = useState(null);

  const [formChanged, setFormChanged] = useState(false); // Track if form is modified
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Handle changes and mark form as modified
  const handleFieldChange = (setter, value) => {
    setter(value);
    setFormChanged(true); // Enable Submit button
  };

  const handleModalClose = () => {
    setTempCity({ value: citySearch, label: cityList.find(c => c.value === citySearch)?.label || experienceData.cityName });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true);
    setIsSubmitting(true); // Disable the button during submission

    // Applying conditions for institution fields
    let compID = 0;
    let orgType = 0;
    let gnrlOrgCompID = 0;

    if (companyListId) {
      //compID = companyListId;
      compID = orgTypeId === 3 ? null : companyListId;
      orgType = orgTypeId === 3 ? 3 : orgTypeId;
      //gnrlOrgCompID = null;
      gnrlOrgCompID = orgTypeId === 3 ? companyListId : null;

    } else if (getOrgInsTId) {
      compID = null;
      orgType = 3;
      gnrlOrgCompID = getOrgInsTId;
    }

    const body = {
      sessionId: sessionId,
      userDataId: userDataInfo.userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,

      // orgType: companyListId === null ? newOrgType : orgType,
      // compID: companyListId,
      // gnrlOrgCompID: getOrgInsTId,
      compID,
      orgType,
      gnrlOrgCompID,

      positionHeadline: profileHeadLine,
      designation: designation,
      description: description,
      cityId: citySearch,
      jobTypeId: jobTypeId,
      workLocationTypeId: workLocationId,
      workLevelTypeId: workLevelId,
      startDate: moment(startDate).format("YYYY-MM-DD"),
      isPresent: isPresent,
      endDate: isPresent === true ? null : moment(endDate).format("YYYY-MM-DD"),
      // endDate === "" || endDate === null
      //   ? null
      //   : moment(endDate).format("YYYY-MM-DD"),
      expId: experienceData.usrDataExpId,
    };
    console.log("body workLocationId", body, workLocationId);

    try {
      const res = await axios.post("/Resume/UpdateExperience", body);
      toast.success(res.data.message);
      handleClose("");
      getUserCv();
      setFormChanged(false); // Disable the button after update
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  // const handleSaveInstitution = () => {
  //     console.log("New Institution Created:", newEducation);
  //     setShowTooltip(false);
  //     setNewEducation("");
  // };

  const [fileName, setFileName] = useState(""); // State to store selected filename
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      setFileName(file.name); // Set the filename in state
    }
  };
  const toggleTooltip = () => {
    console.log("Toggling Tooltip");
    setShowTooltip((prev) => !prev);
  };

  // ...............................City DDL.......................................
  const dispatch = useDispatch();

  const [orgCity, setOrgCity] = useState(null);
  const [citySearch, setCitySearch] = useState("");
  const [tempCity, setTempCity] = useState(null);
  const { cityList, selectedcityId } = useSelector((state) => state.cities);

  useEffect(() => {
    dispatch(fetchCityData());
  }, [dispatch]);
  const handleCityInputChange = (inputValue) => {
    dispatch(fetchCityData(inputValue));
  };

  const handleCityChange = (option) => {
    setTempCity(option); // UI ke liye value change karo
    // if (option) setCitySearch(option.value); // Sirf tab update ho jab user select kare
    handleFieldChange(setCitySearch, option ? option.value : "");
  };

  const handleCitySelect = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectCity(selectedOption.value));
      setCitySearch(selectedOption.value);
    } else {
      setCitySearch(null);
    }
  };

  const [searchTerm, setSearchTerm] = useState("")
  const [cityNameOption, setCityNameOption] = useState([])

  const getCityList = async (pageNumber = 1, pageSize = 10) => {
    try {
      const response = await axios.post(`/MasterData/GetCitiesDDL?Search=${searchTerm}&CountryName=India`, {
        pageNumber,
        pageSize
      })
      console.log("Get City Name List==>", response)
      const cityList = response.data.responseData.citiesDDL.map((val) => ({
        value: val.id,
        label: val.name,
      }));
      setCityNameOption(cityList)
    }
    catch (error) {
      //toast.error(error.message || 'Something went wrong while fetching city data',)
    }
  }

  useEffect(() => {
    getCityList();
  }, [searchTerm]);

  const handleCitySelectOrg = (selectedOption) => {
    setOrgCity(selectedOption ? selectedOption.value : "")
    console.log("Selected City:", selectedOption);
    setSearchTerm(""); // Search term clear karein
    setCityNameOption([]); // Dropdown options clear karein
  };
  const handleCitySelect1 = (selectedOption) => {
    if (selectedOption) {
      setOrgCity(selectedOption.value);
    } else {
      setOrgCity(null);
    }
  };

  // ...............................City DDL.......................................
  // ...............................Job Type DDL.......................................
  const [jobTypeId, setJobTypeId] = useState("");
  const { jobTypeList, selectedJobTypeId } = useSelector(
    (state) => state.jobType
  );
  // console.log('job type',jobTypeList,selectedJobTypeId);

  useEffect(() => {
    dispatch(fetchJobType());
  }, [dispatch]);

  const handleJobType = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectJobType(selectedOption.value));
      setJobTypeId(selectedOption.value);
    } else {
      setJobTypeId(null);
    }
  };
  // ...............................Job Type DDL.......................................
  // ...............................Work Level DDL.......................................
  // Fetch work level data on component mount
  const [workLevelId, setWorkLevelId] = useState("");
  const { workLevelList, selectedworkLevelId } = useSelector(
    (state) => state.workLevelType
  );
  // console.log("Work Level", workLevelList, selectedworkLevelId);

  useEffect(() => {
    dispatch(fetchWorkLevelTypeData());
  }, [dispatch]);

  const handleWorkLevel = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectWorkLevel(selectedOption.value));
      setWorkLevelId(selectedOption.value);
    } else {
      setWorkLevelId(null);
    }
  };

  // ...............................Work Level DDL.......................................
  // ...............................Work Location DDL.......................................

  // Fetch work location data on component mount
  const [workLocationId, setworkLocationId] = useState("");
  const { workLocation, selectedCategoryId } = useSelector(
    (state) => state.workLocationType
  );

  useEffect(() => {
    dispatch(fetchWorkLocationTypeData());
  }, [dispatch]);

  const handleWorkLoc = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectWorkLocation(selectedOption.label));
      setworkLocationId(selectedOption.value);
    } else {
      setworkLocationId(null);
    }
  };

  // ...............................Location DDL.......................................

  // ...............................Company Category DDL.......................................
  const [orgTypeId, setOrgTypeId] = useState("");
  const [regdType, setRegdType] = useState("");

  const [companyListId, setCompanyListId] = useState("");
  const { getRegdCompList, selectedcompaniesId } = useSelector(
    (state) => state.getRegdComp
  );

  useEffect(() => {
    dispatch(fetchOrgRegdCompData());

    // dispatch(fetchCompanyData());
  }, [dispatch]);

  const handleSelectCompany = (selectedOption) => {
    console.log("selectedOption", selectedOption);

    if (selectedOption) {
      // dispatch(selectGetCompanies(selectedOption.value));
      setCompanyListId(selectedOption.value);
      setOrgTypeId(selectedOption.tagId);
      setRegdType(selectedOption.tagId);

    } else {
      setCompanyListId(null);
    }
  };
  const [getOrgInsTId, setGenOrgInstId] = useState(null);
  // ...............................Company Category DDL.......................................

  const handleSaveInstitution = async () => {
    // setDisplay(true);

    const formData = new FormData();
    formData.append("orgName", OrganizationName);
    formData.append("OrgType", "UnRegdInstitution");
    formData.append("CityID", orgCity);
    formData.append("OrgLogo", fileName);
    formData.append("sessionId", sessionId);
    console.log("formData", formData);
    if (
      (companyListId === '' && getOrgInsTId === '') ||
      (orgTypeId === '' && newOrgType === '') ||
      designation === '' ||
      jobTypeId === '' ||
      workLevelId === '' ||
      workLocationId === '' ||
      citySearch === '' ||
      startDate === ''
    ) {
      toast.error('Please fill all the required fields');
    } else {
      try {
        const res = await axios.post("/Feature/AddGnrlOrgData", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        const newOrg = {
          value: res.data.responseData.id,
          label: OrganizationName,
          tagId: 4,
        };
        // console.log("res", res);
        dispatch(fetchOrgRegdCompData());
        setCompanyListId(res.data.responseData.id)
        setInsName("")
        // setGenOrgInstId(res.data.responseData.id);
        // setnewOrgType(res.data.responseData.value);


        toast.success(res.data.message);
        setOrganizationName("")
        setOrgCity(null);
        setFileName("");
        setFormChanged(true);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.error(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred");
        }
      }
    }
  };

  // update experience .....

  const [industryDataId, setIndustryDataId] = useState(null);

  useEffect(() => {
    if (experienceData) {
      setOrgTypeId(experienceData?.orgTypeId);
      setCompanyListId(experienceData?.compId);
      setDesignation(experienceData?.jobTitle);
      setProfileHeadLine(experienceData.positionHeadline);
      setDescription(experienceData?.description);
      setJobTypeId(experienceData?.jobType);
      setWorkLevelId(experienceData?.workLevelType);
      setworkLocationId(experienceData?.workLocationType);
      // setCitySearch(experienceData?.cityId);
      // dispatch(fetchCityData(experienceData?.cityName));
      setCitySearch(experienceData.cityId || ""); // Backend wali value safe rakho
      setTempCity({ value: experienceData.cityId, label: experienceData.cityName }); // UI ke liye
      setIsPresent(experienceData?.isPresent);
      setStartDate(experienceData?.startDate);
      setEndDate(experienceData?.endDate);
    }
  }, [experienceData]);

  console.log("industryDataId", industryDataId, experienceData);
  const [InsName, setInsName] = useState("");

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header>
        <Modal.Title>Update experience</Modal.Title>
        <CloseSharpIcon className="pointer" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="settings">
        <Row>
          {/* Institution and City */}
          <Col md={6} className="mb-2">
            <Form.Group controlId="institution">
              <Form.Group controlId="Company">
                <Form.Label className="class-type">
                  Company<span style={{ color: "red" }}> *</span>
                </Form.Label>
                {InsName !== "" ? (
                  <div>
                    <input
                      type="text"
                      value={InsName}
                      placeholder="Enter Org name"
                      className="mb-2 form-control"
                      disabled
                    />
                  </div>
                ) : (
                  <div className="post-form-group mb-0">
                    <ReactSelect
                      options={getRegdCompList}
                      onChange={(selectedOption) => handleFieldChange(handleSelectCompany, selectedOption)}
                      value={
                        getRegdCompList.find(
                          (option) => {
                            if (InsName !== "" && InsName !== null) {
                              return option.value === InsName;
                            } else {
                              return option.value === companyListId && option.tagId === orgTypeId;
                            }
                          }
                        ) || null
                      }
                      getOptionValue={(option) => `${option.value}-${option.tagId}`}
                      // onChange={handleSelectCompany}
                      // onChange={(option) => {
                      //   handleFieldChange(setCompanyListId, option ? option.value : ""); // Track changes
                      //   setOrgType(option ? option.tag : ""); // Set organization type
                      // }}
                      // value={
                      //   getRegdCompList.find(
                      //     (option) => option.value === companyListId
                      //   ) || null
                      // }
                      formatOptionLabel={(option) => (
                        <div style={{ fontWeight: option.tagId === 2 ? "bold" : "normal" }}>
                          {option.label}
                        </div>
                      )}
                      // styles={{
                      //   control: (provided) => ({
                      //     ...provided,
                      //     boxShadow: "none",  // Removes the blue outline
                      //     borderColor: "#ccc", // Sets a neutral border
                      //     "&:hover": {
                      //       borderColor: "#aaa", // Lighter border on hover
                      //     },
                      //   }),
                      //   option: (provided, state) => ({
                      //     ...provided,
                      //     fontWeight: state.data.tagId === 2 ? "bold" : "normal",
                      //   }),
                      // }}
                      placeholder="Select Company"
                      classNamePrefix="react-select"
                      className="form-control Dark-Input-from-group"
                      styles={customStyles}
                      isClearable
                    />
                  </div>
                )}
              </Form.Group>
              <a
                href="#"
                ref={targetRef}
                onClick={(e) => {
                  e.preventDefault();
                  toggleTooltip();
                }}
                className="createModal"
              // isDisabled={!selectedIndustryId} // Disable until industry is selected
              >
                Create new
              </a>
              <Overlay
                target={targetRef.current}
                show={showTooltip}
                placement="right"
                rootClose
                container={document.querySelector(".modal")}
                onHide={() => setShowTooltip(false)} // Close when clicking outside
              >
                <Popover id="popover-basic" className="overlay-popover-modal">
                  <Popover.Header as="h3" className="Dark-Body-Card-group">Create organization</Popover.Header>
                  <Popover.Body className="Dark-Body-Card-group">
                    <Form>
                      <div>
                        <label className="mb-1 Text-mb-Create">Org name</label>
                        <input
                          type="text"
                          value={OrganizationName}
                          onChange={(e) => {
                            setOrganizationName(e.target.value);
                            setInsName(e.target.value);
                            setCompanyListId(e.target.value);
                            handleFieldChange(setCompanyListId, e.target.value, "companyListId")
                          }}
                          placeholder="Enter Org name"
                          className="mb-2 form-control  Dark-Input-from-group"
                        />
                      </div>
                      <div>
                        <label className="mb-1 Text-mb-Create">City</label>
                        <ReactSelect
                          options={cityNameOption}
                          onInputChange={(value) => setSearchTerm(value)} // User input pe search ho
                          onChange={handleCitySelectOrg} // Select hone ke baad clear ho jaye
                          placeholder="Search & Select City"
                          classNamePrefix="react-select"
                          className="form-control Dark-Input-from-group"
                          styles={customStyles}
                          isClearable
                        />
                      </div>
                      <div className=" mt-2 mb-2 Text-mb-Create">
                        <label className="mb-1">Org logo</label>
                        <input
                          type="file"
                          id="lastName"
                          className="form-control  Dark-Input-from-group"
                          placeholder=""
                          onChange={handleFileChange}
                        />

                      </div>
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={() => {
                            handleSaveInstitution()
                            setShowTooltip(false);
                          }}
                          className="me-2"
                        >
                          Save
                        </Button>
                        <Button
                          variant="secondary"
                          size="sm"
                          onClick={() => setShowTooltip(false)}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Form>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </Form.Group>
          </Col>

          {/* Field, Degree, and Grade */}
          <Col md={6} className="mb-2">
            <Form.Group controlId="grade">
              <Form.Label className="class-type">Designation</Form.Label>
              <Form.Control
                type="text"
                className="Dark-Input-from-group"
                value={designation}
                // onChange={(e) => setDesignation(e.target.value)}
                onChange={(e) => handleFieldChange(setDesignation, e.target.value)} // Track changes
                placeholder="Enter Designation"
              />
              {display && !designation ? (
                <span className="error_msg_lbl">Enter designation </span>
              ) : null}
            </Form.Group>
          </Col>
          <Col md={6} className="mb-2">
            <Form.Group controlId="grade">
              <Form.Label className="class-type">Profile headline</Form.Label>
              <Form.Control
                type="text"
                className="Dark-Input-from-group"
                value={profileHeadLine}
                // onChange={(e) => setProfileHeadLine(e.target.value)}
                onChange={(e) => handleFieldChange(setProfileHeadLine, e.target.value)} // Track changes
                placeholder="Profile Headline"
              />
            </Form.Group>
          </Col>
          <Col md={6} className="mb-2">
            <Form.Group controlId="city">
              <Form.Label className="class-type">
                Employment Type (Job Type)<span style={{ color: "red" }}> *</span>
              </Form.Label>
            </Form.Group>
            <div className="post-form-group">
              <ReactSelect
                options={jobTypeList}
                // onChange={handleJobType}
                onChange={(option) => handleFieldChange(setJobTypeId, option ? option.value : "")} // Track changes
                value={
                  jobTypeList.find((option) => option.value === jobTypeId) ||
                  null
                }
                placeholder="Select Employment type"
                classNamePrefix="react-select"
                className="form-control Dark-Input-from-group"
                styles={customStyles}
                isClearable
              />
            </div>
            {display && !jobTypeId ? (
              <span className="error_msg_lbl">Select employment type </span>
            ) : null}
          </Col>
          <Col md={6} className="mb-2">
            <Form.Group controlId="city">
              <Form.Label className="class-type">
                Work Level Type<span style={{ color: "red" }}> *</span>
              </Form.Label>
            </Form.Group>
            <div className="post-form-group">
              <ReactSelect
                options={workLevelList}
                // onChange={handleWorkLevel}
                onChange={(option) => handleFieldChange(setWorkLevelId, option ? option.value : "")} // Track changes
                value={
                  workLevelList.find(
                    (option) => option.value === workLevelId
                  ) || null
                }
                placeholder="Select Work Level Type"
                classNamePrefix="react-select"
                className="form-control Dark-Input-from-group"
                styles={customStyles}
                isClearable
              />
            </div>
            {display && !workLevelId ? (
              <span className="error_msg_lbl">Select work level type</span>
            ) : null}
          </Col>

          {/* Start Year, End Year, Is Present */}
          <Col md={6} className="mb-2">
            <Form.Group controlId="city">
              <Form.Label className="class-type">
                Work location type<span style={{ color: "red" }}> *</span>
              </Form.Label>
            </Form.Group>
            <div className="post-form-group">
              <ReactSelect
                options={workLocation}
                // onChange={handleWorkLoc}
                onChange={(option) => handleFieldChange(setworkLocationId, option ? option.value : "")} // Track changes
                value={
                  workLocation.find(
                    (option) => option.value === workLocationId
                  ) || null
                }
                placeholder="Select Work Location Type"
                classNamePrefix="react-select"
                className="form-control Dark-Input-from-group"
                styles={customStyles}
                isClearable
              />
            </div>
            {display && !workLocationId ? (
              <span className="error_msg_lbl">Select work location type</span>
            ) : null}
          </Col>

          <Col md={6} className="mb-2">
            <Form.Group controlId="endYear" className=" Flatpickr-Calender-Class">
              <Form.Label className="class-type col-md-12">Start year</Form.Label>
              <Flatpickr
                type="number"
                value={startDate}
                // onChange={(date) => setStartDate(date[0])}
                onChange={(date) => handleFieldChange(setStartDate, (date[0]))} // Track changes
                placeholder="Enter Start Year"
                className="Dark-Input-from-group"
                options={{
                  maxDate: new Date(), // Disable future dates
                  static: true, // Keeps the calendar visible on click         
                }}
              // disabled={isPresent}
              />
              {display && !startDate ? (
                <span className="error_msg_lbl">Enter start year</span>
              ) : null}
            </Form.Group>
          </Col>
          {/* {userDataInfo.isPresentExperience === true && isPresent === false ? (
            ""
          ) : ( */}
          <Col md={6} className="d-flex align-items-center mb-2">
            <Form.Check
              type="checkbox"
              label="Is Present"
              checked={isPresent}
              onChange={(e) => setIsPresent(e.target.checked)}
            />
          </Col>
          {/* )} */}
          {isPresent === false ? (
            <Col md={6} className="mb-2">
              <Form.Group controlId="endYear" className=" Flatpickr-Calender-Class">
                <Form.Label className="class-type col-md-12">End year</Form.Label>
                <Flatpickr
                  type="number"
                  className="Dark-Input-from-group"
                  value={endDate}
                  // onChange={(date) => setEndDate(date[0])}
                  onChange={(date) => handleFieldChange(setEndDate, (date[0]))} // Track changes
                  placeholder="Enter End Year"
                  options={{
                    minDate: startDate || null, // Set minDate to startDate
                    static: true, // Keeps the calendar visible on click         
                  }}
                />
              </Form.Group>
            </Col>
          ) : (
            " "
          )}

          <Col md={6} className="mb-2">
            <Form.Group controlId="city">
              <Form.Label className="class-type">
                City<span style={{ color: "red" }}> *</span>
              </Form.Label>
            </Form.Group>
            <div className="post-form-group">
              <ReactSelect
                options={cityList}
                onInputChange={handleCityInputChange}
                onChange={handleCityChange}
                value={tempCity} // UI me last selected value dikhani hai
                placeholder="Search & Select City"
                classNamePrefix="react-select"
                className="form-control Dark-Input-from-group"
                styles={customStyles}
                isClearable={true}
                onBlur={handleModalClose} // Jab modal close ho ya focus hatayen, pehli value restore ho
              />
            </div>
            {display && !citySearch ? (
              <span className="error_msg_lbl">Search & select city</span>
            ) : null}
          </Col>

          <Col md={12} className="mb-2">
            <Form.Group controlId="description">
              <Form.Label className="class-type">Description</Form.Label>
              <Form.Control
                as="textarea"
                className="Dark-Input-from-group"
                rows={3}
                value={description}
                // onChange={(e) => setDescription(e.target.value)}
                onChange={(e) => handleFieldChange(setDescription, e.target.value)} // Track changes
                placeholder="Enter Description"
              />
            </Form.Group>
          </Col>

          {/* Description */}
        </Row>

        {/* Submit Button */}

        <div className="d-flex justify-content-end mt-4">
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3"
              onClick={handleSubmit}
              style={{ cursor: formChanged ? "pointer" : "default" }}
            >
              <a href="#/"
                // className=""
                // onClick={handleSubmit}
                className={`btn  ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
                disabled={!formChanged || isSubmitting}
                style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
              >
                Submit
              </a>
            </div>
          </div>
        </div>

      </Modal.Body>
    </Modal>
  );
};

export default EditExperience;
